import React, {Fragment} from 'react'
import styles from './SaveSuccess.scss'
import {FancyCheckmark} from 'common/FancyCheckmark'
import {ModalOverlay} from 'common/styleguide/ModalOverlay'
import {CTA} from 'common/styleguide/CTA'
import {urls} from 'lib/urls'
import {capitalize} from 'lib/utils'
import {pl} from 'lib/textUtils'
import cx from 'classnames'

export class SaveSuccess extends React.PureComponent {
  render () {
    const {troute, organizedInEvents, organizedInExperiences, organizedInClub, objectType, onRequestClose} = this.props
    const ownerText = organizedInClub
      ? <span> <a href={urls.organizations.routes(organizedInClub.id)}>{organizedInClub.name}</a>'s route library</span>
      : <span> your {objectType}s</span>

    return (
      <ModalOverlay
        maxWidth='600px'
        contentPadding={false}
        title={<div>Saved <strong>{troute.name}</strong></div>}
        onRequestClose={onRequestClose}
        footer={<Footer troute={troute} objectType={objectType} />}>
        <div className={styles.body}>
          <FancyCheckmark />
          <div>
            <strong>{troute.name}</strong> has been saved to
            {ownerText}
            {organizedInEvents && organizedInEvents.size > 0 && <OrganizedIn
              organizables={organizedInEvents}
              organizableString='event'
              path={urls.events.show}
              last={!organizedInExperiences || organizedInExperiences.size === 0} />}
            {organizedInExperiences && organizedInExperiences.size > 0 && <OrganizedIn
              organizables={organizedInExperiences}
              organizableString='Experience'
              path={urls.experiences.edit}
              last />}
          </div>
        </div>
      </ModalOverlay>
    )
  }
}

const OrganizedIn = ({organizables, organizableString, path, last}) => {
  return <span>{`,${last ? ' and' : ''} organized in your ${pl(organizables.size, organizableString, {includeCount: false})}: `}
    {organizables
      .valueSeq()
      .map((e, k) => <Fragment key={e.id}>
        <a key={e.id} href={path(e.id)}>{e.name}</a>
        {organizables.size > 2 && k < organizables.size - 1 && ', '}
        {organizables.size > 2 && k === organizables.size - 2 && 'and '}
        {organizables.size === 2 && (k === 0) && ' and '}
      </Fragment>)}
  </span>
}

const Footer = ({troute, objectType}) => {
  return (
    <div className={styles.footer}>
      <CTA
        to={`${urls[`${objectType}s`].show(troute.id)}?openShare=true`}
        link
        margins={false}
        className={cx(styles.specificity, styles.leftLink)}>
        Share {capitalize(objectType)}
      </CTA>
      {objectType === 'route' && <CTA
        link
        margins={false}
        onClick={() => window.location.assign(`/${objectType}s/${troute.id}/send_to_device`)}
        className={cx(styles.specificity, styles.middleLink)}>
        Send to Device
      </CTA>}
      <CTA
        to={urls[`${objectType}s`].show(troute.id)}
        margins={false}
        className={styles.specificity}>
        View {capitalize(objectType)}
      </CTA>
    </div>
  )
}
